import { render, staticRenderFns } from "./taskIndex.vue?vue&type=template&id=40399d16&scoped=true"
import script from "./taskIndex.vue?vue&type=script&lang=js"
export * from "./taskIndex.vue?vue&type=script&lang=js"
import style0 from "./taskIndex.vue?vue&type=style&index=0&id=40399d16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40399d16",
  null
  
)

export default component.exports